module.exports = __webpack_public_path__ + "static/media/catalouge-01.02549ab8.jpg";